import { useState, useEffect } from 'react';
import { getSensitiveDataVisible, setSensitiveDataVisible } from '@/lib/data-service';

export function useSensitiveData() {
  const [visible, setVisibleState] = useState<boolean>(() => getSensitiveDataVisible());

  useEffect(() => {
    const handleVisibilityChange = (event: Event) => {
      const customEvent = event as CustomEvent<{ visible: boolean }>;
      setVisibleState(customEvent.detail.visible);
    };

    window.addEventListener('sensitiveDataVisibilityChanged', handleVisibilityChange);
    return () => window.removeEventListener('sensitiveDataVisibilityChanged', handleVisibilityChange);
  }, []);

  const setVisible = (newVisible: boolean) => {
    setSensitiveDataVisible(newVisible);
    setVisibleState(newVisible);
  };

  return { visible, setVisible };
}
